export enum TaskType {
  Blocks,
  PreInspection,
  AirWaybill,
  BeneficialOwner,
}
